import { defaultProps } from "../utils";
import { Fade as RFade } from "react-reveal";
export const Fade = defaultProps({ duration: 500 })(RFade);
